import { render } from "./Document.vue?vue&type=template&id=dc43bf94&scoped=true"
import script from "./Document.vue?vue&type=script&lang=js"
export * from "./Document.vue?vue&type=script&lang=js"

import "./Document.vue?vue&type=style&index=0&id=dc43bf94&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc43bf94"]])

export default __exports__